const transcript = {

    // List
    transcriptList: 'Transcript List',
    searchCriteria: 'Filter Preset',
    presetName: 'Enter Preset Name',
    transcript: 'Transcript',
    termTranscript: 'Term Transcript',
    yearTranscript: 'Year Transcript',
    fullTranscript: 'Full Transcript',

    // View
    officialTranscript: 'Official Transcript',
    provisionalTranscript: 'Provisional Transcript',
    validSeal: 'Not valid without the seal of SBS Swiss Business School',
    major: 'Major:',
    specialization: 'Specialization:',
    academicYear: 'Academic Year(s):',
    studentName: 'Student Name:',
    studentNumber: 'Student Number:',
    studentMatriculationNumber: 'Student / Matriculation Nr:',
    birthDate: 'Birth Date:',
    birthPlace: 'Birth Place:',
    reportDate: 'Report Date:',
    semester: 'Semester',
    term: 'Term',
    code: 'Code',
    course: 'Course',
    percentage: 'Percentage',
    grade: 'Grade',
    sbsCredits: 'SBS Credits',
    ectsCredits: 'ECTS Credits',
    gradePointAverage: 'Grade point average: {gpa} on a 4.0 Scale',
    localGradePointAverage: 'Grade point average: {local_gpa} on a {maximum_grade} Scale',
    total: 'Total:',
    cumulativeGPA: 'Cumulative GPA: {gpa} on a 4.0 Scale',
    localCumulativeGPA: 'Cumulative GPA: {local_gpa} on a {maximum_grade} Scale',
    totalECTS: 'Total ECTS earned:',
    totalSBS: 'Total SBS earned:',
    secondaryMajor: 'Secondary Major',
    notObtainedText: 'Student has not obtained the final degree',
    documentIssuedText: 'This document is issued in',
    registrar: 'Registrar',
    notFound: 'No Yearly transcript record found.',
    notFoundSecondary: 'No Secondary Yearly transcript record found.',
    degreeDate: 'Degree conferral date:',
    page1: 'Grades for core courses see page 1',
    introduced: 'ECTS Credits introduced as of October 2010.',
    campusAttended: 'Campus attended:',
    campusEnrolled: 'Campus enrolled:',
    enrollmentLocation: 'Enrollment Location:',
    institutionAdministeringStudies: 'Institution administering studies: Edstone Global',
    studyMode: 'Study mode: Part-time',
    hkmaInstitute: 'Institution administrating studies: The Hong Kong Management Association (HKMA)',
    aaeRemarksTerm: 'Semester 5. and 6.',
    aaeRemarksCredit: 'TC (Semester 1-4) equivalent to:',
    mastersDegreeProgram: "MASTER'S DEGREE PROGRAM",
    bachelorsDegreeProgram: "BACHELOR'S DEGREE PROGRAM",
    furtherEducationProgram: "FURTHER EDUCATION PROGRAM",
};

export default transcript;